import React from "react";

export const isSimulatedDemo = (row) =>
  !!(row && ((row.labels || []).includes("SIMULATED_DEMO") || row.meta?.simulated_demo || row.simulated_demo));

export const DemoBadge = ({ testid, label = "Demo", title = "Simulated demo data — not a real communication" }) => (
  <span
    className="inline-flex items-center h-[16px] px-1.5 rounded ring-1 ring-slate-200 bg-slate-50 text-[9.5px] font-semibold uppercase tracking-[0.06em] text-slate-500 shrink-0"
    title={title}
    data-testid={testid}
  >
    {label}
  </span>
);
